import useSWR from 'swr';
import { apiBaseURL } from '../../Utils/ProjectConstants';
import useFetch from '../useFetch';
import { useNavigate } from 'react-router-dom';


export default function useHandleWorkCenter() {
    const navigate = useNavigate()
        , fetch = useFetch(navigate);

    const { data, error, isLoading } = useSWR(`${apiBaseURL}/api/WorkCenter`, {
        onSuccess: (data) => console.log('Work Centers fetched successfully:', data?.data),
        revalidateOnFocus: false,
        dedupingInterval: 300000,
    });
    const allWorkCenterData = data?.data;
    const workCenters = data?.data?.map((x) => ({ name: x.name, id: x.id, tasks: x.tasks }));

    return {
        workCenters,
        allWorkCenterData,
        error,
        isLoading
    }
}